import React from "react";

export const unwrapData = (o) => {
    while (o && o.data) o = o.data;
    return o;
};

export const emailRegex = /^[a-zA-Z0-9._-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,8}$/i;

export const updateQueryParam = (paramName, paramValue) => {
    if (typeof window !== undefined) {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set(paramName, paramValue);
        window.history.pushState({ query: queryParams.toString() }, '', `?${queryParams.toString()}`);
    }
};

export const findKey = (objectOfObjects) => {
    for (const key in objectOfObjects) {
        if (objectOfObjects.hasOwnProperty(key)) {
            const innerObject = objectOfObjects[key];
            if (innerObject.AM === true || innerObject.PM === true) {
                return {
                    key,
                    time: innerObject.AM === true ? 'AM' : 'PM'
                };
            }
        }
    }
    return null;
}

export const getValueByKey = (arr, propName, propValue) => {
    return arr.find(i => i[propName] === propValue);
}

const forbiddenNumbers = [
    "3334439694",
    "3308181667",
    "3308222222"
]

export const isForbiddenNumber = (phoneNumber) => {
    const normalizedPhoneNumber = normalizePhoneNumber(phoneNumber);

    const withoutCountryCode = normalizedPhoneNumber.startsWith('44')
        ? normalizedPhoneNumber.slice(2)
        : normalizedPhoneNumber.startsWith('0')
        ? normalizedPhoneNumber.slice(1)
        : normalizedPhoneNumber;

    return forbiddenNumbers.includes(withoutCountryCode);
}

const normalizePhoneNumber = (phoneNumber) => {
    return phoneNumber.trim().replace(/[^0-9]/g, '');
};

export const getProperty = (object, propKey) => {
    if (object) {
        return object[propKey]
    }
}

export const isStagingOrDevelopment = () => {
    const hostName = window.location.host;
    return /staging|localhost/.test(hostName);
};

export const isProduction = () => {
    const hostName = window.location.host;
    return !isStagingOrDevelopment();
};

export const findOfferParams = (location) => {
    const params = new URLSearchParams(location);

    const customerType = params.get('CustomerType');
    const code = params.get('code');

    if (
        customerType !== undefined &&
        customerType !== null &&
        code !== undefined &&
        code !== null
    ) {
        return {
            customerType,
            code
        };
    } else {
        return false;
    }
}

export const findCodeParams = (location) => {
    const params = new URLSearchParams(location);

    const code = params.get('code');

    if (
        code !== undefined &&
        code !== null
    ) {
        return code;
    } else {
        return false;
    }
}

export const getAssociativeArray = (array, keyName) => {
    const tempArr = [];
    array.forEach(element => {
        tempArr[element[keyName]] = element;
    });
    return tempArr;
}

export const sanitizeTextForLineBreaks = (text) => {
    if (text)
        if (text.indexOf('\n') !== -1)
            return text.split('\n').map((item, key) => (
                <span key={key}>{item}<br /></span>
            ))

        else if (text.indexOf('<br>') !== -1) {
            return text.split('<br>').map((item, key) => (
                <span key={key}>{item}<br /></span>
            ))
        }
        else
            return <span>{text}</span>
}

export const getUrlParams = () => {
    return (typeof window !== 'undefined')? new URLSearchParams(window.location.search) : null;
};



export const createLeadContactBillingAddressPayload = (FormData) => {
   try {
    const payload = [
      {
        entity: 'CrmModule:Lead',
        title: FormData.address,
        properties: {
          Type: 'RESIDENTIAL',
          Name: FormData.address,
          EmailAddress: FormData.email,
        },
        associations: []
      },
      {
        entity: 'CrmModule:Contact',
        title: `${FormData.firstName} ${FormData.lastName}`,
        properties: {
          EmailAddress: FormData.email,
          Title: FormData.title?.value,
          FirstName: FormData.firstName,
          LastName: FormData.lastName,
          Phone: FormData.phone,
          TwilioVerifiedPhone: true,
          TermsAndConditionsConsent: FormData?.termsAndConditionsConsent || false,
          MarketingConsent: FormData?.marketingConsent || false,
          MarketingSMS: FormData?.MarketingSMS || false
        }
      },
      {
        entity: 'CrmModule:Address',
        title: FormData.address,
        properties: {
          FullAddress: FormData.address,
          SPRN: FormData.SPRN,
          UDPRN: FormData.UDPRN,
          UPRN: FormData.UPRN,
          UMPRN: FormData.UMPRN,
          Type: 'BILLING',
          PostalCode: FormData.postalCode
        },
      },
    ];

    return payload;

  } catch (error) {
    console.log('debug -> Error while creating payload for registration.', error);
    return {Message: error, StatusCode: 500};
  }
};
  